"use strict";

// babel polyfill
require("@babel/polyfill");

if (process.env.NODE_ENV !== "test") {
  // fetch() polyfill for making API calls.
  require("whatwg-fetch");

  // URLSearchParam Polyfill
  require("url-search-params-polyfill");
}

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
if (process.env.NODE_ENV === "test") {
  require("raf").polyfill(global);
}
